export enum LoginType {
  email = 'email',
  primaryPhone = 'primaryPhone',
  username = 'username',
}
